module.exports = [
    "spurGearReducer",
    "WormGearReducer",
    "helicalGearReducer",
    "bevelGearReducer",
    "BevelGearReducer",
    "HypoidGearReducer",
    "harmonicReducer",
    "parallelGearReducer",
    "planetaryGearReducer",
    "SpineaReducer"
]
